import SCheck from "@public/image/icon/check.svg";
import { cn } from "@/utils/cn";

interface PricingFeaturesProps {
  features: string[];
  className?: string;
}

function PricingFeatures({ features, className }: PricingFeaturesProps) {
  return (
    <div className={cn("flex flex-col gap-4", className)}>
      {features.map((feature) => (
        <div key={feature} className="flex items-center gap-3 text-16">
          <SCheck className="size-4 fill-primary" />
          {feature}
        </div>
      ))}
    </div>
  );
}

export default PricingFeatures;
